import React, {useEffect, useRef, useState} from 'react';
import {useAuth, useMain} from "../../hooks";
import friends from "../../assets/images/friends.jpg";
import refer from "../../assets/images/refer.png";
import {cf} from "../../utils";
import s from "../../styles/Shared.module.css";
import d from "../../styles/Dashboard.module.css";
import share from "../../assets/svg/share.svg";
import {Link} from "react-router-dom";
import copy from 'copy-to-clipboard';
import {toast, ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const InviteFriend = () => {
  const [isShareModalOpen, setIsShareModalOpen] = useState(false)
  const {
    userDetails: ud,
  } = useAuth()
  const {isSmall} = useMain()
  const bgRef = useRef()
  useEffect(() => {
    bgRef.current.style.background = `url(${friends})`
    bgRef.current.style.backgroundPosition = 'center'
    bgRef.current.style.backgroundRepeat = 'no-repeat'
    bgRef.current.style.backgroundSize = 'cover'
    bgRef.current.style.position = 'relative'
  }, [])


  useEffect(() => {
    if (isShareModalOpen) document.scrollingElement.style.overflow = "hidden"
    else document.scrollingElement.style.overflowY = "auto"
  }, [isShareModalOpen])

  const handleCopy = (text) => {
    copy(text);
    return toast('Referral code copied!', {
      autoClose: 2000,
      hideProgressBar: true,
      type: 'success'
    });
  };

  return (
    <>
      <ToastContainer/>
      <div
        className={cf(
          s.flex,
          s.flex_dColumn,
          s.flexLeft,
          d.kycParent,
          // isSmall ? s.wMax : '',
          isSmall ? s.mT20 : '',
          d.cta
        )}
        ref={bgRef}
      >
        <div className="absolute inset-0 bg-slate-900 opacity-70 rounded-[15px]"></div>
        <div className="relative">
        <span className={cf(s.wMax, s.flex, s.flexLeft, d.ctaTitle)}>
				Invite a friend
			</span>
          <span className={cf(s.wMax, s.flex, s.flexLeft, d.ctaText)}>
				By investing and diligently tracking your earnings, you can work towards
				building a more secure financial future.
			</span>
          <button
            onClick={() => setIsShareModalOpen(true)}
            className={cf(
              s.flex,
              s.spaceXBetween,
              s.spaceYCenter,
              d.sBrowse,
              d.noMargin,
              d.angel,
              s.wMax
            )}
          >
            <span className={cf(s.flex, s.flexCenter)}>Send Invitation</span>
            <img
              src={share}
              alt={'plus icon'}
              className={cf(s.flex, d.sPlus)}
            />
          </button>
        </div>
      </div>
      {
        isShareModalOpen && (
          <div className="fixed inset-0 flex justify-center items-center">
            <div onClick={() => setIsShareModalOpen(false)}
                 className="fixed inset-0 bg-slate-900 opacity-80"></div>
            <div className="w-[300px] bg-black rounded relative">
              <img
                src={refer}
                alt={'plus icon'}
                className="w-full h-[150px] bg-[#efc951] object-contain rounded-t"
              />
              <div className="p-4">
                <p className={cf(s.flex, s.flexLeft, d.walBal)}>Earn more from talking</p>
                <p className="text-[14px] font-[400] text-gray-500 leading-[1.1]">Earn 1% of every purchase from people
                  you refer on cribvest</p>
                <div onClick={() => handleCopy(ud.user.referer)} className="cursor-pointer my-5 space-y-4">
                  <div className="flex gap-4 items-center">
                    <div className="bg-red-100 p-2 rounded-full">
                      <svg className="w-[20px] h-[20px] text-red-500" stroke="currentColor" fill="currentColor"
                           stroke-width="0" viewBox="0 0 512 512" height="200px"
                           width="200px" xmlns="http://www.w3.org/2000/svg">
                        <rect width="336" height="336" x="128" y="128" fill="none" stroke-linejoin="round"
                              stroke-width="32"
                              rx="57" ry="57"></rect>
                        <path fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"
                              d="m383.5 128 .5-24a56.16 56.16 0 0 0-56-56H112a64.19 64.19 0 0 0-64 64v216a56.16 56.16 0 0 0 56 56h24"></path>
                      </svg>
                    </div>
                    <p className="text-[14px] font-[400] text-white leading-[1.1]">Copy referral code</p>
                  </div>
                  <div>
                    <Link to={`https://wa.me/?text=${ud.user.referer}`} target="_blank">
                      <div className="flex gap-4 items-center">
                        <div className="bg-green-100 p-2 rounded-full">
                          <svg className="w-[20px] h-[20px] text-green-500" stroke="currentColor" fill="currentColor"
                               stroke-width="0" viewBox="0 0 448 512" height="200px"
                               width="200px" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"></path>
                          </svg>
                        </div>
                        <p className="text-[14px] font-[400] text-white leading-[1.1]">Share on whatsapp</p>
                      </div>
                    </Link>
                  </div>
                  <div className="flex gap-4 items-center">
                    <div className="bg-blue-100 p-2 rounded-full">
                      <svg className="w-[20px] h-[20px] text-blue-500" stroke="currentColor" fill="currentColor"
                           stroke-width="0" viewBox="0 0 512 512" height="200px"
                           width="200px" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M378 324a69.78 69.78 0 0 0-48.83 19.91L202 272.41a69.68 69.68 0 0 0 0-32.82l127.13-71.5A69.76 69.76 0 1 0 308.87 129l-130.13 73.2a70 70 0 1 0 0 107.56L308.87 383A70 70 0 1 0 378 324z"></path>
                      </svg>
                    </div>
                    <p className="text-[14px] font-[400] text-white leading-[1.1]">Share</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }
    </>
  )
};

export default InviteFriend;
